import type { ListDataParams } from './types';

/** Avoid mutating caller objects when API methods attach filters/search to `listData`. */
export function shallowCopyListData(listData: ListDataParams): ListDataParams {
  return {
    ...listData,
    filters: listData.filters ? { ...listData.filters } : undefined,
    sort: listData.sort ? { ...listData.sort } : undefined
  };
}
